<template>
  <div class="card-graph-container">
    <div ref="graph" class="graph" />

    <div class="qs-legend">
      <div v-for="(data, i) in graphLabels" :id="'qs-legend-' + i" :key="i">
        <span class="bullet" :style="{ backgroundColor: data.color }"></span>
        <span class="legend-value">{{ data.value }}</span>
        <span class="legend-description">{{ data.i18n }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import PieGraph from '@/components/ecs-wallboard-card/ecs-interactions-slide/d3-pie-graph/d3-pie-graph';

export default {
  name: 'EcsInteractionsGraph',

  props: {
    interactions: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      dataset: [],
      graph: null
    };
  },

  computed: {
    graphLabels() {
      const interactionsToShow = Object.keys(this.interactions).map(interaction => interaction);

      return this.dataset.filter(data => interactionsToShow.includes(data.i18n.toLowerCase()));
    }
  },

  watch: {
    interactions() {
      this.updateGraph();
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.$nextTick();
      this.graph = new PieGraph(this.$refs.graph, []);

      this.updateGraph();
    },

    async updateGraph() {
      await this.$nextTick();

      this.dataset = [
        {
          i18n: 'Abandoned',
          value: this.interactions.abandoned || 0,
          color: '#f44336'
        },
        {
          i18n: 'Answered',
          value: this.interactions.answered || 0,
          color: '#4ea96d'
        },
        {
          i18n: 'Overflow',
          value: this.interactions.overflow || 0,
          color: '#ffc107'
        },
        {
          i18n: 'Waiting',
          value: this.interactions.waiting || 0,
          color: '#123abc'
        }
      ];

      if (this.graph && this.graph.updateDataset) {
        this.graph.updateDataset(this.dataset);
      }
    }
  }
};
</script>

<style scoped>
.graph {
  height: 180px;
  padding: 0 4px;
}

.card-graph-container {
  background-color: #fff;
  margin: 0 10px;
  border-radius: 4px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qs-legend {
  font-size: 12px;
}

.legend-title {
  font-size: 16px;
  color: var(--v-xtium-robin-egg-blue);
  padding: 0 0 8px 6px;
}

legend > div {
  transition: all 0.2s ease;
}

.legend-description {
  color: #666;
  transition: all 0.2s ease;
}

[dark] .legend-description {
  color: var(--v-surface-lighten4);
}

.legend-value {
  display: inline-block;
  font-size: 13px;
  padding-right: 8px;
  text-align: right;
  min-width: 20px;
  white-space: nowrap;
}

.bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 12px;
  margin: 0 8px;
}
</style>
